/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';
import Link from "./Link";
var propTypes = {
  render: PropTypes.func,

  /** @ignore */
  target: PropTypes.string
};
var defaultProps = {
  render: function render(props) {
    return React.createElement("a", props);
  }
};
export function AppFooterLink(props) {
  var rel = props.target && props.target === '_blank' ? 'noopener noreferrer' : undefined;
  return React.createElement(Link, Object.assign({}, props, {
    rel: rel
  }));
}
AppFooterLink.propTypes = propTypes;
AppFooterLink.defaultProps = defaultProps;
export default AppFooterLink;